import { api, setAuthToken, setRefreshToken, URLs } from '@/libs/api'
import type { LoginCredentials, LoginResponse } from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { authApiMock } from '@/libs/mocks/handlers/auth'

const getRefreshToken = () => localStorage.getItem('refreshToken')

const authApiReal = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    return await api.post<LoginResponse>(URLs.LOGIN, credentials).then((response) => {
      const { accessToken, refreshToken } = response.data
      setAuthToken(accessToken)
      if (refreshToken) setRefreshToken(refreshToken)
      // Backend sends explicit `null` for role fields on org memberships
      // with no assigned role — normalize to `undefined` at the boundary.
      return {
        ...response.data,
        orgs: response.data.orgs.map((org) => ({
          ...org,
          roleID: org.roleID ?? undefined,
          roleName: org.roleName ?? undefined,
        })),
      }
    })
  },
  logout: async (): Promise<void> => {
    await api.post(URLs.LOGOUT, { refreshToken: getRefreshToken() })
  },
}

export const authApi: typeof authApiReal = IS_MOCK_MODE ? authApiMock : authApiReal
